module.exports = __webpack_public_path__ + "img/mobile-rental-assets-05.afa8ee15.png";